import { Table } from "@similarweb/pro-logic-components";

import type { WebsitesDigitalAssetRecord } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";

import { getNoData } from "../../../../constants";
import { DigitalAssetsLoader } from "../DigitalAssetsLoader";
import { EmptyState } from "../EmptyState";
import { StyledTableContainer } from "../styles";

import { getWebsitesDigitalAssetsColumns } from "./columns";
import { SingleDomainView } from "./SingleDomainView";
import { useFilteredTableData } from "./useFilteredTableData";

type Props = {
    companyName: string;
    data: readonly WebsitesDigitalAssetRecord[] | undefined;
    isLoading: boolean;
    isFetched: boolean;
};

const WebsitesTabContent = ({ companyName, data, isLoading, isFetched }: Props) => {
    const { displayedData, totalRow, isEmpty, paginationProps } = useFilteredTableData(data, isLoading, isFetched);

    if (isLoading) {
        return <DigitalAssetsLoader />;
    }

    if (isEmpty) {
        return <EmptyState />;
    }

    if (displayedData.length === 1) {
        return (
            <SingleDomainView
                digitalAsset={displayedData[0]}
                companyName={companyName}
            />
        );
    }

    const columnsConfig = getWebsitesDigitalAssetsColumns(displayedData.length, totalRow);

    return (
        <StyledTableContainer>
            <Table
                isLoading={isLoading}
                data={displayedData}
                columnConfig={columnsConfig}
                pagination={paginationProps}
                noData={getNoData()}
                bordersConfig={{ body: false, header: false }}
                edgeColumnsPadding="md"
                withArrowButtons={false}
            />
        </StyledTableContainer>
    );
};

export default WebsitesTabContent;
